import css from "../assets/css.png";
import python from "../assets/python.png";
import java from "../assets/java.png";
import cpp from "../assets/cpp.png";
import go from "../assets/go.png";
import php from "../assets/php.png";
import javascript from "../assets/javascript.png";
import html from "../assets/html.png";

export const data = [
  {
    name: "Javascript",
    img: javascript,
    options: ["Website Development", "1995", "Brendan Eich"],
  },
  {
    name: "HTML",
    img: html,
    options: ["Website Development", "1993", "Tim Berners-Lee"],
  },
  {
    name: "CSS",
    img: css,
    options: ["Website Design", "1994", "Håkon Wium Lie"],
  },
  {
    name: "Python",
    img: python,
    options: ["AI", "1980", "Guido van Rossum"],
  },
  {
    name: "Java",
    img: java,
    options: ["Backend", "1990s", "Sun Microsystems"],
  },
  {
    name: "C++",
    img: cpp,
    options: ["Game Dev.", "1980s", "Bjarne Stroustrup"],
  },
  {
    name: "Go",
    img: go,
    options: ["Network", "2009", "Robert Griesemer"],
  },
  {
    name: "PHP",
    img: php,
    options: ["Backend", "1995", "	Rasmus Lerdorf"],
  },
];
